import React, { Component } from "react";
import {
  configMonthToDate,
  monthOptions,
  transformResponseMTD,
  yearOptions,
} from "../config";
import { configMonthToDateBySales } from "./confg";
import * as R from "ramda";
import FlexView from "react-flexview";
import { fetchDataAsync } from "../../../../../Services/Utils";
import Api from "../../../../../Services/Api";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import { mapToObjectDDL, removeNullFields } from "../../../../common/mapper";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import { HttpStatus } from "../../../../common/Constants";

class MonthToDateSalesReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      month: null,
      year: null,
      tableConfig: [],
      dataTable: [],
      dataTable1: [],
      dataTable2: [],
      dataTL: [],
      dataSales: [],
      teamLead: null,
      sales: null,
    };
  }

  componentDidMount = async () => {
    let currentDate = new Date();
    this.setState((prevValue) => ({
      ...prevValue,
      ...prevValue,
      // month: monthOptions.find((item) => item.value === currentDate.getMonth()),
      month: monthOptions.find(
        (item) => item.value === currentDate.getMonth() + 1,
      ),
      year: yearOptions.find(
        (item) => item.value === currentDate.getFullYear(),
      ),
      tableConfig:
        this.props.tab === "tl"
          ? configMonthToDateBySales
          : configMonthToDate || [],
    }));
    if (!R.isNil(this.props.kodeCabang?.value)) {
      if (this.props.tab === "salesman") {
        return this.fetchDataSales();
      }
      return this.fetchDataTL();
    }
  };

  componentDidUpdate = async (prevProps) => {
    const prevCabang = prevProps.kodeCabang?.value;
    const currCabang = this.props.kodeCabang?.value;

    if (prevCabang !== currCabang && currCabang) {
      this.setState({
        sales: null,
        dataSales: [],
        dataTL: [],
        dataTable: [],
        dataTable1: [],
        dataTable2: [],
      });

      if (this.props.tab === "salesman") {
        await this.fetchDataSales();
      } else {
        await this.fetchDataTL();
      }
    }
  };

  fetchDataTL = async () => {
    try {
      let res = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllMasterSales,
        setError: this.props.setError,
        menuName:
          "Dashboard Level Kepala Cabang Keatas - Laporan Harian By Sales",
        args: {
          paramFilters: {
            kodeCabang: this.props.kodeCabang?.value,
            userNameLead: this.props.usernameLogin,
          },
        },
      });
      if (res.ok) {
        this.setState((prevValue) => ({
          ...prevValue,
          dataTL: res.data.data.map((item) =>
            mapToObjectDDL(item.salesLeadName, item.employeeId),
          ),
        }));
      }
    } catch (e) {
      console.log("error", e);
    }
  };

  fetchDataSales = async () => {
    try {
      // todo change api to get all sales not just tl
      let res = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA").getSalesDropdownForDashboard,
        setError: this.props.setError,
        menuName:
          "Dashboard Level Kepala Cabang Keatas - Laporan Harian By Sales",
        args: { employeeIdTeamLeader: this.props.idLeader, kodeCabang: this.props.kodeCabang?.value},
      });
      if (res.ok) {
        this.setState((prevValue) => ({
          ...prevValue,
          dataSales: res.data.data.map((item) =>
            mapToObjectDDL(item.name, item.employeeId),
          ),
        }));
      }
    } catch (e) {
      console.log("error", e);
    }
  };

  fetchData = async () => {
    if (R.equals(this.props.tab, "salesman")) {
      this.fetchDataMTD();
      this.fetchDataMTD(true);
    } else {
      this.fetchDataMTDSales();
    }
  };

  fetchDataMTD = async (isMergeLeasing) => {
    try {
      this.props.triggerLoading();
      const res = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_REPORT_DTO").getLaporanPenjualanMTD,
        setError: this.props.setError,
        menuName: "Dashboard Level Team Leader - Laporan Penjualan Bulanan",
        args: {
          month: this.state.month?.value,
          year: this.state.year?.value,
          employeeIdSales: this.state.sales?.value,
          kodeCabang: [this.props.kodeCabang?.value],
          mergerLeasing: isMergeLeasing,
        },
      });
      if (res.ok && res.data.status === HttpStatus.SUCCESS) {
        if (!isMergeLeasing) {
          this.setState((prevValue) => ({
            ...prevValue,
            dataTable1: transformResponseMTD(res.data.data),
          }));
        } else {
          this.setState((prevValue) => ({
            ...prevValue,
            dataTable2: transformResponseMTD(res.data.data),
          }));
        }
      }
      this.props.triggerLoading();
    } catch (error) {
      this.props.triggerLoading();
      console.error("Error fetching data: ", error);
    }
  };

  transformResponseToTableMTDSales = (data) => {
    return [
      ...data.data,
      {
        name: "Total",
        lastMonth: data.totalLastMonth,
        thisMonth: data.totalThisMonth,
        growth: data.growth,
        forecasting: data.totalForecasting,
      },
    ];
  };

  fetchDataMTDSales = async () => {
    try {
      const res = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_REPORT_DTO").getLaporanJualanMTDSalesmanCS,
        setError: this.props.setError,
        menuName: "Dashboard Level Kacab - Laporan Jualan MTD Salesman CS",
        args: {
          kodeCabang: [this.props.kodeCabang?.value],
          year: this.state.year?.value,
          month: this.state.month?.value,
          mode: "SALESMAN",
          idLeader: this.state.sales?.value,
        },
      });
      if (res.ok && res.data.status === HttpStatus.SUCCESS) {
        this.setState((prevValue) => ({
          ...prevValue,
          dataTable: this.transformResponseToTableMTDSales(res.data.data),
        }));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  handleSearch = () => {
    this.fetchData();
  };

  handleSearchValueChange = (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      [name]: value,
    }));
  };

  render() {
    return (
      <>
        <FlexView style={{ gap: "20px", alignItems: "center" }}>
          <SimpleDDL
            isClearable
            id="select_options_month"
            box="search"
            name="month"
            containerclassname="width width-250px"
            placeholder="Bulan"
            menuPosition="fixed"
            options={monthOptions}
            value={this.state.month}
            onChange={(value, { name }) =>
              this.handleSearchValueChange(name, value)
            }
          />
          <SimpleDDL
            isClearable
            id="select_options_year"
            box="search"
            name="year"
            containerclassname="width width-250px"
            placeholder="Tahun"
            menuPosition="fixed"
            options={yearOptions}
            value={this.state.year}
            onChange={(value, { name }) =>
              this.handleSearchValueChange(name, value)
            }
          />
          <SimpleDDL
            id="select_options_sales"
            box="search"
            name="sales"
            isClearable
            containerclassname="width width-250px"
            placeholder={this.props.tab === "tl" ? "Nama TL" : "Nama Sales/CS"}
            menuPosition="fixed"
            options={
              this.props.tab === "tl" ? this.state.dataTL : this.state.dataSales
            }
            value={this.state.sales}
            onChange={(value, { name }) =>
              this.handleSearchValueChange(name, value)
            }
          />
          <SimpleButton
            styles={{ marginBottom: "15px" }}
            onClick={() => this.handleSearch()}
          >
            Cari
          </SimpleButton>
        </FlexView>
        {this.props.tab === "salesman" && (
          <FlexView style={{ gap: "50px" }}>
            <SimpleDataTable
              data={this.state.dataTable1}
              columns={this.state.tableConfig}
              options={{
                serverSide: false,
                rowsPerPage: 50,
                rowsPerPageOptions: [],
              }}
            />
            <SimpleDataTable
              data={this.state.dataTable2}
              columns={this.state.tableConfig}
              options={{
                serverSide: false,
                rowsPerPage: 50,
                rowsPerPageOptions: [],
              }}
            />
          </FlexView>
        )}
        {this.props.tab === "tl" && (
          <SimpleDataTable
            data={this.state.dataTable}
            columns={this.state.tableConfig}
            options={{
              serverSide: false,
              rowsPerPage: 50,
              rowsPerPageOptions: [],
            }}
          />
        )}
      </>
    );
  }
}

export default MonthToDateSalesReport;
